import React, { useContext, useEffect, useMemo, useState } from 'react';
import { TableLayoutContext } from '../../layout-context';
import { debounce } from '../../table-helpers/debounce';
import { StyledCell, StyledTooltip, TooltipContent } from './styled';
// for some browsers there might be a difference of 1-2px between
// offsetHeight and scrollHeight even when both present on a same line and practically the same.
const HEIGHT_OFFSET = 3;
const renderTooltipArrayCell = (cell) => {
    var _a, _b;
    const arrayLength = cell.value.length;
    if (typeof cell.value[0] === 'object' && cell.value[0] !== null) {
        const textKey = ((_b = (_a = cell.value) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.name) ? 'name' : 'title';
        return (React.createElement(TooltipContent, null, cell.value.map((item, i) => (React.createElement("div", { key: `${item}-${i}` }, `${item[textKey]}${i < arrayLength - 1 ? ',' : ''} `)))));
    }
    return (React.createElement(TooltipContent, null, cell.value.map((item, i) => (React.createElement("div", { key: `${item}-${i}` }, `${item}${i < arrayLength - 1 ? ',' : ''}  `)))));
};
export const BodyCell = ({ cell, selectedRowIds, additionalProps }) => {
    const layoutType = useContext(TableLayoutContext);
    const [disabled, setDisabled] = useState(false);
    const tooltipRef = React.useRef(null);
    useEffect(() => {
        const onResize = debounce(() => {
            const node = tooltipRef.current;
            if ((node === null || node === void 0 ? void 0 : node.firstChild) && (!Array.isArray(cell.value) || cell.value.length <= 1)) {
                const hasCut = node.firstChild.offsetHeight + HEIGHT_OFFSET <
                    node.firstChild.scrollHeight;
                setDisabled(!hasCut);
            }
        }, 200);
        window.addEventListener('resize', onResize);
        onResize();
        return () => {
            window.removeEventListener('resize', onResize);
            onResize.cancel();
        };
    }, []);
    const tooltipContent = useMemo(() => {
        if (Array.isArray(cell.value)) {
            return renderTooltipArrayCell(cell);
        }
        const cellType = typeof cell.value;
        if (cellType === 'number' || cellType === 'string')
            return cell.value;
        return null;
    }, [cell]);
    const tooltipStyleProp = cell.column.tooltipStyle;
    const tooltipStyle = useMemo(() => {
        if (disabled)
            return null;
        if (typeof tooltipStyleProp === 'function')
            return tooltipStyleProp(cell);
        return tooltipStyleProp;
    }, [tooltipStyleProp, cell, disabled]);
    return (React.createElement(StyledCell, { as: layoutType === 'block' ? 'div' : undefined, "$isPinned": cell.column.pinned, ...cell.getCellProps([
            // todo: fix any type
            { style: cell.column.style, className: cell.column.className }
        ]) }, tooltipContent ? (React.createElement(StyledTooltip, { ref: tooltipRef, content: tooltipContent, disabled: disabled, "$external": tooltipStyle },
        React.createElement("span", null, cell.render('Cell', { selectedRowIds, additionalProps })))) : (React.createElement("span", null, cell.render('Cell', { selectedRowIds, additionalProps })))));
};
